import React from "react";
import Filters from "./Filters";
import ListTemplate from "components/ListTemplate";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { cardLayout } from "./cardLayout";
import { useLoaderData } from "react-router";
import TrainModal from "train/TrainModal";

const GroundTransportListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.GroundTransportListFrontModel>();
  return <>
    <TrainModal />
    <ListTemplate
      title={RESX.GroundTransport.GroundTransports}
      filterSet="groundTransport_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.GroundTransport.Paginated}
      getId={item => item.groundTransportId}
      layout={cardLayout()}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default GroundTransportListApp;
